exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1LwpHRrY7Xt8UgRJBtEjsc{\n    width: 200px;\n    height: 80px;\n    background: var(--control-background);\n    border-radius: 5px;\n    margin: 1rem 0;\n}\n", ""]);
// Exports
exports.locals = {
	"item": "_1LwpHRrY7Xt8UgRJBtEjsc"
};